module.exports = __webpack_public_path__ + "static/media/fast-backward.bc802a25.svg";